import { FC } from 'react';
import { useNavigate } from "react-router-dom";
import css from './index.module.css';
import * as Types from '../../types';
import { statusIcons, statusText } from '@pages/account/order.info';

const Order: FC<Types.MiniOrder> = ({ id, miniId, createdAt, status }) => {
    const navigate = useNavigate();

    function convertToDate(isoDate: any) {
        const date = new Date(isoDate);
        return new Intl.DateTimeFormat('ru-Ru', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }).format(date);
    }

    return (
        <div className={css.order} onClick={() => navigate(`/webapp/order/${id}`)}>
            <div className={css.header}>
                <div className={css.left}>
                    <a>{miniId} • {convertToDate(createdAt)}</a>
                </div>
            </div>
            
            <div className={css.body}>
                <div className={css.left}>
                    <a className={css.status}>{statusIcons[status]} {statusText[status]}</a>
                </div>
            </div>
        </div>
    );
};

export default Order;